var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isGuidanceTipShow
    ? _c(
        "el-row",
        { staticClass: "tooltip-line-content-wrapper" },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              { staticClass: "guidance-tip" },
              [
                _vm._v(" " + _vm._s(_vm.content) + " "),
                _vm._t("btn", function () {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "bind-btn",
                        on: {
                          click: function () {
                            return _vm.$store.commit("setShopVisiable", {
                              visiable: true,
                            })
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("stores::store::bind_shop")) + " "
                        ),
                      ]
                    ),
                  ]
                }),
                _vm.tip
                  ? _c(
                      "span",
                      { staticClass: "bind-btn", on: { click: _vm.onClick } },
                      [_vm._v(_vm._s(_vm.$t("system::common::btn::example")))]
                    )
                  : _vm._e(),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showClose,
                      expression: "showClose",
                    },
                  ],
                  staticClass: "close-img",
                  attrs: {
                    src: require("../../assets/images/userGuidance/close.png"),
                    alt: "",
                  },
                  on: {
                    click: function () {
                      _vm.isGuidanceTipShow = false
                      _vm.$emit("close")
                    },
                  },
                }),
              ],
              2
            ),
          ]),
          _c(
            "div",
            { staticStyle: { overflow: "hidden", height: "0", width: "0" } },
            [
              _vm.tip
                ? _c("el-image", {
                    ref: "imgShow",
                    attrs: { "preview-src-list": [_vm.tip], src: _vm.tip },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }